<template>
    <div class="tw-bg-white tw-rounded-lg tw-shadow-smx tw-border tw-overflow-hidden tw-border-gray-200">
        <div class="tw-rounded tw-overflow-auto tw-border tw-border-solid tw-border-gray-100">
            <table class="tw-min-w-full tw-leading-normal">
                <thead class="">
                    <tr>
                        <th v-for="c in columns" :key="c.name" :class="c.classes"
                            class="tw-px-5 last:tw-border-e-0 tw-whitespace-nowrap tw-border-e tw-py-3 tw-border-b tw-borderx tw-border-gray-100 tw-bg-gray-50 tw-text-start tw-text-[12px] tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider">
                            {{ $t(c.label) }}
                        </th>
                    </tr>
                </thead>

                <tbody v-if="props.loading">
                    <tr class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50"
                        v-for="i in 10" :key="i">
                        <td v-for="c in columns" :key="c.name" class="tw-px-2 tw-py-3">
                            <div
                                class="tw-w-full tw-py-3 tw-bg-gray-50 group-even:tw-bg-white tw-rounded tw-min-w-[30px] tw-animate-pulse">
                            </div>
                        </td>
                    </tr>
                </tbody>

                <tbody v-else>
                    <template v-if="items.length > 0">
                        <CompanyTableRow v-for="item in items" :key="item.id" :item="item" @edit="onEdit"
                            @delete="onDelete" @view="onView" />
                    </template>
                    <template v-else>
                        <tr>
                            <td :colspan="columns.length">
                                <div
                                    class="tw-p-8 tw-bg-white tw-min-h-[250px] tw-text-gray-600 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center">
                                    <icon icon="solar:buildings-2-bold-duotone"
                                        class="tw-text-4xl tw-text-gray-300 tw-mb-4" />
                                    <p class="tw-text-lg tw-font-medium tw-mb-2">{{ $t('messages.no-companies-found',
                                        'No companies found') }}</p>
                                    <p class="tw-text-sm tw-text-gray-500">{{ $t('messages.no-companies-description',
                                        'Try adjusting your search or filters') }}</p>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

    </div>

    <div class="tw-mt-2">
        <TablePagination v-if="items.length > 0" :has-next="!!options.next_page_url" :has-previous="!!options.prev_page_url"
            @previous="emit('previous')" @next="emit('next')" />
    </div>

</template>

<script setup>
import { ref, defineProps, defineEmits, toRef } from 'vue';
import TablePagination from '@/components/table/TablePagination.vue';
import CompanyTableRow from './CompanyTableRow.vue';

const props = defineProps(['loading', 'data', 'items', 'options']);
const items = toRef(props, 'items');
const emit = defineEmits(['next', 'previous', 'edit', 'delete', 'view']);

const columns = ref([
    { name: 'id', label: 'fields.id', classes: ['tw-w-[60px]'] },
    { name: 'name', label: 'fields.name', classes: ['tw-min-w-[200px]'] },
    { name: 'primary_email', label: 'forms.company.primary-email', classes: ['tw-min-w-[180px]'] },
    { name: 'primary_phone', label: 'forms.company.primary-phone', classes: ['tw-w-[130px]'] },
    { name: 'country', label: 'forms.company.country', classes: ['tw-w-[120px]'] },
    { name: 'categories', label: 'fields.categories', classes: ['tw-w-[150px]'] },
    { name: 'certificates', label: 'fields.certificates', classes: ['tw-w-[150px]'] },
    { name: 'users_count', label: 'fields.users_count', classes: ['tw-w-[100px]'] },
    { name: 'social_media', label: 'fields.social-media', classes: ['tw-w-[120px]'] },
    // { name: 'status', label: 'fields.status', classes: ['tw-w-[100px]'] },
    // { name: 'created_at', label: 'fields.created_at', classes: ['tw-w-[130px]'] },
    { name: 'actions', label: 'fields.actions', classes: ['tw-w-[120px]'] },
]);

const onEdit = (company) => {
    emit('edit', company);
};

const onDelete = (company) => {
    emit('delete', company);
};

const onView = (company) => {
    emit('view', company);
};
</script>

<style scoped>
/* Add any custom styles here */
</style>